"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const js_cookie_1 = __importDefault(require("js-cookie"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const apiFetch_1 = require("@app/utils/apiFetch");
/**
 * Custom hook for managing coins/rubies/diamonds reward system.
 * - Initializes values from DOM element and cookies.
 * - Provides methods to add rewards and track correct streaks.
 * - Persists earned rewards to the server.
 */
const useCoins = () => {
    /** Current coin count */
    const [coinCount, setCoinCount] = (0, react_1.useState)(0);
    /** Current ruby count */
    const [rubyCount, setRubyCount] = (0, react_1.useState)(0);
    /** Current diamond count */
    const [diamondCount, setDiamondCount] = (0, react_1.useState)(0);
    /** Correct answers counter (used for thresholds) */
    const [correctCounter, setCorrectCounter] = (0, react_1.useState)(0);
    /** Language ID (from cookies) */
    const [language, setLanguage] = (0, react_1.useState)(null);
    const langId = js_cookie_1.default.get("lang_id");
    /**
     * On mount: get language ID from cookies.
     */
    (0, react_1.useEffect)(() => {
        setLanguage(langId);
    }, []);
    /**
     * On mount: initialize counts (coins, rubies, diamonds)
     * from DOM element attributes (#ezspeech-react-front).
     */
    (0, react_1.useEffect)(() => {
        const rootElement = document.getElementById('ezspeech-react-front');
        const coins = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-coins')) || 0;
        const diamonds = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-diamonds')) || 0;
        const rubies = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-rubies')) || 0;
        setCoinCount(+coins);
        setRubyCount(+rubies);
        setDiamondCount(+diamonds);
    }, []);
    /**
     * Increases correct counter and depending on threshold:
     * - awards a coin, ruby, or diamond,
     * - saves the reward on the server,
     * - plays the corresponding sound effect.
     *
     * @param rubyThreshold - threshold for ruby reward
     * @param diamondThreshold - threshold for diamond reward
     */
    const addCoin = (rubyThreshold = 0, diamondThreshold = 0) => __awaiter(void 0, void 0, void 0, function* () {
        let coinType = '';
        setCorrectCounter((prevCounter) => {
            const newCounter = prevCounter + 1;
            switch (newCounter) {
                case diamondThreshold:
                    coinType = +language === 1 ? 'Diamond' : 'Diamond_en';
                    console.debug(coinType, 111111);
                    setDiamondCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 0, 1);
                    return 0;
                case rubyThreshold:
                    coinType = +language === 1 ? 'Rubin' : 'Rubin_en';
                    setRubyCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 1, 0);
                    return newCounter;
                default:
                    setCoinCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 0, 1);
                    return newCounter;
            }
        });
        yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, "correct"));
    });
    /**
     * Resets correct counter back to zero.
     */
    const clearCoinCounter = () => {
        setCorrectCounter(0);
    };
    /**
     * Persists earned rewards (coins, rubies, diamonds) to the server.
     *
     * @param coins - number of coins earned
     * @param rubies - number of rubies earned
     * @param diamonds - number of diamonds earned
     */
    const saveEarnedCoins = (coins, rubies, diamonds) => __awaiter(void 0, void 0, void 0, function* () {
        const coinsEarned = {
            coin: coins,
            ruby: rubies,
            diamond: diamonds,
        };
        try {
            yield (0, apiFetch_1.apiFetch)('/save_reward/', {
                method: 'POST',
                body: JSON.stringify(coinsEarned),
            });
        }
        catch (error) {
            console.error('Error saving coins:', error);
        }
    });
    return {
        coinCount,
        rubyCount,
        diamondCount,
        addCoin,
        clearCoinCounter,
        saveEarnedCoins,
        correctCounter,
    };
};
exports.default = useCoins;
